module.exports = __webpack_public_path__ + "static/media/home_product.692a5181.png";